module.exports = __webpack_public_path__ + "img/@logo_posri.afa75796.jpg";